module.exports = __webpack_public_path__ + "img/snapchat_ghost.1e259409.svg";